import React from 'react';
import { Row, Col, Button } from 'reactstrap';
import { HeadquarterInput } from '.';
import { ComponentCard } from '../layout/ComponentCard';

import cedesca from '../assets/images/cedesca.png';
import cntec from '../assets/images/cntec.png';

export const ListadoEmpresas = ({ local, setEmpresaId, next, beginning }) => {
  const fullName = `${local.nombre} ${local.apellidos}`;

  // Función para controlar los radio buttons
  const onChangeRadioValue = (e) => {
    setEmpresaId(e.target.value);
  };

  return (
    <Col md="12">
      <ComponentCard title="Seleccionar empresa" name={fullName} className="clearfix">
        <Row className="mb-5">
          <Col md="6 text-center">
            <HeadquarterInput
              headquarter="CEDESCA"
              imgUrl={cedesca}
              onChange={onChangeRadioValue}
            />
          </Col>
          <Col md="6 text-center">
            <HeadquarterInput headquarter="CNTEC" imgUrl={cntec} onChange={onChangeRadioValue} />
          </Col>
        </Row>
        <Button className="float-left" onClick={beginning}>
          Volver fichar alumno
        </Button>
        <Button className="float-end" onClick={() => next(0)}>
          Siguiente
        </Button>
      </ComponentCard>
    </Col>
  );
};
